/// <reference types="vite/client" />

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  createRootRoute,
  HeadContent,
  Outlet,
  Scripts,
} from "@tanstack/react-router";
import lightgalleryThumbnail from "lightgallery/css/lg-thumbnail.css?url";
import lightgalleryZoom from "lightgallery/css/lg-zoom.css?url";
import lightgallery from "lightgallery/css/lightgallery.css?url";
import type { ReactNode } from "react";
import { siteMeta } from "@/lib/seo";
import appCss from "@/styles/app.css?inline";
import appCssUrl from "@/styles/app.css?url";

const queryClient = new QueryClient();

export const Route = createRootRoute({
  head: () => ({
    meta: [
      {
        charSet: "utf-8",
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1",
      },
      ...siteMeta,
    ],
    links: [
      ...(process.env.NODE_ENV === "development"
        ? [
            {
              rel: "stylesheet",
              href: appCssUrl,
            },
          ]
        : []),
      {
        rel: "stylesheet",
        href: lightgallery,
      },
      {
        rel: "stylesheet",
        href: lightgalleryThumbnail,
      },
      {
        rel: "stylesheet",
        href: lightgalleryZoom,
      },
      {
        rel: "stylesheet",
        href: "https://use.typekit.net/egu5fyl.css",
      },
    ],
    styles: [
      ...(process.env.NODE_ENV === "production"
        ? [
            {
              children: appCss,
            },
          ]
        : []),
    ],
    scripts: [
      // {
      //   src: "//unpkg.com/react-scan/dist/auto.global.js",
      //   crossOrigin: "anonymous",
      // },
    ],
  }),
  component: RootComponent,
});

function RootComponent() {
  return (
    <QueryClientProvider client={queryClient}>
      <RootDocument>
        <Outlet />
      </RootDocument>
    </QueryClientProvider>
  );
}

function RootDocument({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <html lang="de">
      <head>
        <HeadContent />
      </head>
      <body>
        {children}

        {/* WUUNU SNIPPET - DON'T CHANGE THIS (START) */}
        {/* <script id="wuunu-ws" strategy="afterInteractive">
          {`window.__WUUNU_WS__ = "http://127.0.0.1:50300/";`}
        </script>
        <script
          crossOrigin="anonymous"
          id="wuunu-widget"
          src="https://cdn.jsdelivr.net/npm/@wuunu/widget@0.1?cacheParam=1"
          strategy="afterInteractive"
        /> */}
        {/* WUUNU SNIPPET - DON'T CHANGE THIS (END) */}
        <Scripts />
      </body>
    </html>
  );
}
